import React from "react";
import { Link, useLocation } from "react-router-dom";
import AppShell from "@/components/AppShell";
import { MISSION, usd } from "@/components/Mission";
import { getProfile } from "@/lib/profileStore";

export default function SaverSharePage() {
  const location = useLocation();
  const { unlocked = 0, total = 0 } = location.state || {};
  const profile = getProfile();
  const headline = unlocked > 0 ? unlocked : total;
  const firstName = (profile?.name || "I").split(" ")[0] || "I";

  return (
    <AppShell>
      <div className="py-10 max-w-2xl mx-auto" data-testid="share-root">
        <h1 className="font-heading italic text-4xl sm:text-5xl text-[#0f172a] mb-2">Share your savings</h1>
        <p className="text-slate-600 mb-8">Take a screenshot of the card below — sized for Instagram, Twitter, and LinkedIn.</p>

        <div className="aspect-[4/5] sm:aspect-square w-full max-w-lg mx-auto rounded-3xl border border-[#bfdbfe] bg-gradient-to-br from-[#0f172a] via-[#1d4ed8] to-[#0f172a] text-white p-10 flex flex-col justify-between shadow-xl"
          data-testid="share-card">
          <div>
            <p className="text-[11px] uppercase tracking-[0.3em] text-white/70" data-testid="share-mission-eyebrow">The AidWaive promise</p>
            <p className="font-heading italic text-xl mt-2 text-white/90">"{MISSION}"</p>
          </div>
          <div>
            <p className="text-sm text-white/70 mb-1">AidWaive found {firstName}</p>
            <div className="font-heading italic text-6xl sm:text-7xl leading-none" data-testid="share-amount">{usd(headline)}</div>
            <p className="text-sm text-white/80 mt-3">in college savings.</p>
          </div>
          <div className="flex items-baseline justify-between text-xs text-white/60">
            <span>aidwaive.com</span>
            <span className="font-heading italic">AidWaive</span>
          </div>
        </div>

        <div className="mt-6 flex items-center justify-between gap-3">
          <Link to="/app/saver" className="text-sm text-[#1d4ed8] hover:underline" data-testid="share-back-link">← back to playbook</Link>
          <p className="text-xs text-slate-400">Right-click the card or screenshot it to share.</p>
        </div>
      </div>
    </AppShell>
  );
}
